import { Link, useLocation } from "wouter";
import { Button, EmptyState, Logo } from "../ui/index.ts";

/** A path nothing answers. Inside the app it sits in the shell; signed out it gets its own page with the logo. */
export function NotFound({ standalone }: { standalone?: boolean }) {
  const [, navigate] = useLocation();
  const state = (
    <EmptyState
      art="lost"
      title="This page doesn't exist."
      action={<Button onClick={() => navigate("/", { replace: true })}>{standalone ? "Go to the homepage" : "Back to today"}</Button>}
    />
  );
  if (!standalone) return state;
  return (
    <main className="flex min-h-dvh flex-col bg-page px-5 pb-8 pt-6 md:px-10">
      <Link href="/" aria-label="Headcount home" className="self-start rounded-control">
        <Logo size={22} />
      </Link>
      <div className="grid flex-1 place-items-center pb-16">{state}</div>
    </main>
  );
}
